<template>
  <el-dialog
    :title="$t('reportCustomGroupManage.edit')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose">
    <el-form :model="editReportCustomGroupInfo" :rules="rules" ref="editForm" label-width="120px">
      <el-form-item :label="$t('reportCustomGroupManage.groupName')" prop="name">
        <el-input v-model="editReportCustomGroupInfo.name" 
                  :placeholder="$t('reportCustomGroupManage.inputGroupNameRequired')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('reportCustomGroupManage.groupUrl')" prop="url">
        <el-input v-model="editReportCustomGroupInfo.url" 
                  :placeholder="$t('reportCustomGroupManage.inputGroupUrlRequired')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('reportCustomGroupManage.description')" prop="remark">
        <el-input type="textarea" v-model="editReportCustomGroupInfo.remark" 
                  :placeholder="$t('reportCustomGroupManage.inputDescriptionRequired')"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editReportCustomGroup">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateReportCustomGroup } from '@/api/dev/reportCustomGroupApi'

export default {
  name: 'EditReportCustomGroup',
  data() {
    return {
      dialogVisible: false,
      editReportCustomGroupInfo: {
        groupId: '',
        name: '',
        url: '',
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('reportCustomGroupManage.groupNameRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('reportCustomGroupManage.groupNameMaxLength'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('reportCustomGroupManage.groupUrlRequired'), trigger: 'blur' },
          { max: 512, message: this.$t('reportCustomGroupManage.groupUrlMaxLength'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('reportCustomGroupManage.descriptionRequired'), trigger: 'blur' },
          { max: 512, message: this.$t('reportCustomGroupManage.descriptionMaxLength'), trigger: 'blur' }
        ],
        groupId: [
          { required: true, message: this.$t('reportCustomGroupManage.groupIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.editReportCustomGroupInfo = { ...row }
    },
    handleClose() {
      this.$refs.editForm && this.$refs.editForm.clearValidate()
    },
    editReportCustomGroup() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        
        try {
          await updateReportCustomGroup(this.editReportCustomGroupInfo)
          this.$message.success(this.$t('reportCustomGroupManage.editSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('修改报表组失败:', error)
          this.$message.error(error.message || this.$t('reportCustomGroupManage.editFailed'))
        }
      })
    }
  }
}
</script>